import { Page } from '../../features/layouts';

/**
 * @deprecated Use Page from '@connected/ui/features/layouts' instead
 * @see {@link file://packages/ui/src/features/layouts/components/page.tsx}
 *
 * @example
 * // Old usage:
 * import { ContentLayout } from '@connected/ui/layouts/content/layout';
 *
 * // New usage:
 * import { Page } from '@connected/ui/features/layouts';
 */
export const ContentLayout = Page;
